import { defineStore } from 'pinia';
import { ref } from 'vue';

export class DealProcessesRunning {
	// Wether we're in the processing of submitting a credit application to Ally (Soft-pull program)
	isAutoSubmitToAlly: boolean = false;
	constructor() {
		this.isAutoSubmitToAlly = false;
	}
}

export const useDealProcessesRunningStore = defineStore('dealProcessesRunning', () => {
	// State
	const CreditApplicationProcesses = ref<DealProcessesRunning>(new DealProcessesRunning());

	function setSubmittingCreditApplication(value: boolean) {
		CreditApplicationProcesses.value.isAutoSubmitToAlly = value;
	}

	return {
		CreditApplicationProcesses,
		setSubmittingCreditApplication,
	};
});
